/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayPlayerMetricsDtoSchema } from "./goodLuck/core/DTOs/replayPlayerMetricsDtoSchema.ts";
import { z } from "zod/v4";

export const getBracketsMatchesMatchidReplayMetricsPathParamsSchema = z.object({
  matchId: z.string(),
});

/**
 * @description OK
 */
export const getBracketsMatchesMatchidReplayMetrics200Schema = z.array(
  z.lazy(() => goodLuckCoreDTOsReplayPlayerMetricsDtoSchema),
);

export const getBracketsMatchesMatchidReplayMetricsQueryResponseSchema =
  getBracketsMatchesMatchidReplayMetrics200Schema;
